/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaProductFidelioItemizerDTO = {
    _06: '06',
    _01: '01',
    _03: '03',
    _05: '05',
    _07: '07',
    _02: '02',
    _08: '08',
    _04: '04',
    _10: '10',
    _41: '41',
    _42: '42'
} as const;
export type SpaProductFidelioItemizerDTO = typeof SpaProductFidelioItemizerDTO[keyof typeof SpaProductFidelioItemizerDTO];

